import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Link, Tooltip, tokens } from '@hotjar/hotsauce';
import { motion, AnimatePresence } from 'framer-motion';

import { useRealTimeStore } from '../store/realTimeStore';

const StyledLink = styled(Link)`
  ${tokens.text('link')}
  color: ${tokens.color.text_default};
  font-weight: 500;
  text-decoration: none;
`;

const WrapperDiv = styled.div`
  display: inline-flex;
  margin-left: -${tokens.spacer.x1};
  white-space: pre;
`;

interface Props {
  onClick: () => void;
}

const SkipCurrentInactivityButtonUnMemo = ({ onClick }: Props): JSX.Element => {
  const { t } = useTranslation();
  const isActiveSection = useRealTimeStore(
    (state) =>
      state.sectionInfoList.length > 0 && state.sectionInfoList[state.currentSectionIndex].isActive,
  );
  return (
    <WrapperDiv>
      <AnimatePresence>
        {!isActiveSection && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <Tooltip text={t('common:player.skip-current-inactivity-tooltip')} placement="top">
              <StyledLink onClick={onClick} as="button" kind="inline">
                {t('common:player.skip-pauses')}
              </StyledLink>
            </Tooltip>
          </motion.div>
        )}
      </AnimatePresence>
    </WrapperDiv>
  );
};

export const SkipCurrentInactivityButton = memo(SkipCurrentInactivityButtonUnMemo);
